module.exports = __webpack_public_path__ + "img/softIndexOrange.01942c8b.png";